<template>
  <div 
    class="cpt-hide-group-title h-[30px] flex-items-center font-bold text-[12px] leading-[18px] text-op-4 px-[8px] relative" 
    @click="handleClick" 
    :class="{ 
      hide: isHide, 
      banned, 
    }" 
    :style="{'color': is_gradient ? '' : title_color}"
  >
    <template v-if="room">
      <i class="iconfont icon-room icon-right-room flex-center" @click.stop="$emit('roomIcon')" v-if="room.is_available"></i>
      <i class="icon-arrow-down iconfont"></i>
      <ChatRoomAvatar
        :width="18"
        :img="room.room_avatar"
        :room_name="room.room_name"
        :webp_quality="50"
        :radius="3"
        :keep_active="true"
        :chat_img_props="{
          hover_dom_handler: () => this.$el
        }"
      />
    </template>
    <template v-else-if="role_id">
      <RoleAvatar
        :no_lazy="no_avatar_lazy"
        :img="role_img"
        class="icon-group-title"
        size="small"
        :color="title_color"
        :gradient="is_gradient"
      />
    </template>
    <template v-else>
      <i class="icon-arrow-down iconfont"></i>
    </template>

    <slot name="left-icon"></slot>

    <span
      v-emoji-html="{text: text, className: 'w-[12px]'}"
      :style="{'background-image': gradient_color}"
      class="ellipsis"
      :class="{
        'bg-gradient': is_gradient
      }" 
    ></span>
  </div>
</template>

<script>
import RoleAvatar from "./RoleAvatar.vue";
import { decimalToHexColor } from "_lib/utils/utilsColor";
export default {
  props: {
    isHide: {
      type: Boolean
    },
    text: {
      type: String,
      default: '',
    },
    room: {
      type: Object
    },
    banned: {
      type: Boolean,
      default: false
    },
    color: {
      type: [Number, Array],
      default: -1,
    },
    role_id: {
      type: String,
    },
    role_img: {
      type: String,
    },
    no_avatar_lazy: {
      type: Boolean,
      default: false
    }
  },
  components: {
    RoleAvatar
  },
  computed: {
    title_color() {
      if (this.is_gradient) {
        const arr = this.color.map(item => decimalToHexColor(item))
        return arr.join(',')
      }
      return this.color == -1 ? '' : decimalToHexColor(this.color, 'var(--opacity-6)')
    },
    is_gradient () {
      return Array.isArray(this.color) && this.color.length > 1 && this.color[0] != this.color[1]
    },
    gradient_color() {
      if (!this.is_gradient) return ''
      const arr = this.color.map(item => decimalToHexColor(item))
      return `linear-gradient(90deg, ${arr[0]} 0%, ${arr[1]} 100%)`
    }
  },
  methods: {
    handleClick() {
      if( this.banned ) return
      this.$emit('click')
    }
  }
}
</script>

<style lang="scss">
.cpt-hide-group-title {
  &.banned {
    &:hover {
      background: none;
      cursor: auto;
      .icon-arrow-down {
        opacity: 0;
      }
    }
  }

  &:hover {
    background: $d-op-1;
    border-radius: 5px;
    cursor: pointer;
    margin-left: -3px;
    padding-left: 11px;
    .icon-arrow-down {
      opacity: 1;
    }
    .icon-room {
      display: flex;
    }
  }
  .icon-arrow-down {
    opacity: 0;
    width: 6px;
    height: 6px;
    color: $d-tx-4;
    position: absolute;
    left: 1px;
    top: 13px;
    transition: 0.1s transform linear;
    &::before {
      font-size: 12px;
      width: 12px;
      height: 12px;
      transform: scale(0.5);
      transform-origin: left top;
    }
  }
  .icon-right-room {
    width: 24px;
    height: 24px;
    position: absolute;
    top: 4px;
    right: 4px;
    cursor: pointer;
    color: $d-tx-3;
    display: none;
    &:hover {
      background: $d-op-2;
      border-radius: 3px;
    }
    &::after {
      width: 16px;
      height: 16px;
      font-size: 16px;
    }
  }
  .icon-group-title {
    width: 15px;
    height: 15px;
    font-size: 15px;
    margin-right: 6px;
  }
  &.hide {
    margin-left: -3px;
    padding-left: 11px;
    .icon-arrow-down {
      opacity: 1;
      transform: rotate(-90deg);
    }
  }
  .cpt-chat-room-avatar {
    margin-right: 8px;
  }
}
</style>
